<template>
    <div class="editor-section-container">
        <router-view></router-view>
    </div>
</template>

<script>
    import EventBus from "@/utils/event-bus";
export default {
    name: "EditorSection",
    beforeRouteLeave(to, from, next) { 
        if (from.name === 'editor.scene') { // see routes/index.js
           EventBus.$emit('editor:outsideClick'); // this will close the contextMenu if being shown, see context_menu_mixin
           EventBus.$emit('editor:outsideShowlayersClick');
           EventBus.$emit('editor:closeWarningModal'); // in case it is opened
           this.$store.commit('editor/resetAnimationTimelineTime');
        }
        next();
    },
     
}

</script>

<style scoped>
.editor-section-container {
    width: 100%;
    height: 100%;
    position: relative;
}
</style>
